var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { title: "操作说明", visible: _vm.isShow, width: "640px" },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c("div", [
        _c("img", {
          staticClass: "img-width",
          attrs: {
            src: require("@/assets/images/recharge/rechare-card.png"),
            alt: "",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }